import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Collapsible admin section: a clickable title bar + a body that shows when open.
export function AccordionSection({
  title, defaultOpen = false, children,
}: { title: string; defaultOpen?: boolean; children: React.ReactNode }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="mt-5 bg-[var(--glass-bg)] backdrop-blur-[12px] border border-[var(--glass-border)] rounded-[16px] overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left cursor-pointer bg-transparent border-none"
      >
        <span className="text-[16px] font-semibold text-[color:var(--text-primary)]">{title}</span>
        <ChevronDown size={18} className={`text-[color:var(--text-muted)] transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && <div className="px-5 pb-5">{children}</div>}
    </section>
  );
}
